module.exports = __webpack_public_path__ + "assets/5548cbaa3e377642e3fc30c903a3a8e7.mp3";